// test2277
(2277 && 0);
